import type { ReactElement } from 'react'
import { QrCode } from '@/components/QrCode'
import { Button, Modal } from '@/components/ui'
import styles from './QrPosterModal.module.css'

export interface QrPosterModalProps {
  open: boolean
  onClose: () => void
  title: string
  url: string
  serverName: string | null
  requiresApproval: boolean
}

export function QrPosterModal({
  open,
  onClose,
  title,
  url,
  serverName,
  requiresApproval,
}: QrPosterModalProps): ReactElement {
  const handlePrint = (): void => {
    window.print()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Printable QR Poster"
      size="md"
      footer={
        <>
          <Button onClick={onClose}>Close</Button>
          <Button variant="primary" onClick={handlePrint}>
            Print Poster (A4)
          </Button>
        </>
      }
    >
      <div className={styles.posterContainer}>
        <div className={styles.poster}>
          <div className={styles.header}>
            <span className={styles.spaceBadge}>{serverName ?? 'Relaii Space'}</span>
            <h1 className={styles.posterTitle}>{title}</h1>
            <p className={styles.posterSubtitle}>
              Scan the QR code with your mobile camera to join the conversation.
            </p>
          </div>

          <div className={styles.qrWrapper}>
            <QrCode value={url} size={220} className={styles.qr} />
          </div>

          <div className={styles.instructions}>
            <div className={styles.step}>
              <span className={styles.stepNum}>1</span>
              <span>Open camera on phone</span>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNum}>2</span>
              <span>Tap the link that appears</span>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNum}>3</span>
              <span>Choose name & password</span>
            </div>
          </div>

          {requiresApproval ? (
            <div className={styles.approvalNotice}>
              <strong>Note:</strong> Membership requires approval by an administrator before access is granted.
            </div>
          ) : (
            <div className={styles.instantNotice}>
              Instant setup — you will be added directly into the channels.
            </div>
          )}

          <div className={styles.footer}>
            <span className={styles.footerUrl}>{url}</span>
          </div>
        </div>
      </div>
    </Modal>
  )
}
